import React, { useState } from 'react';
import { Portfolio } from '../types';
import { User } from '../services/auth';
import FamilyMembers from './FamilyMembers';
import Investments from './Investments';
import { Users } from 'lucide-react';

interface FamilyProps {
  portfolio: Portfolio;
  setPortfolio: (portfolio: Portfolio) => void;
  user: User | null;
}

type TabType = 'members' | 'investments';

const Family: React.FC<FamilyProps> = ({ portfolio, setPortfolio, user }) => {
  const [activeTab, setActiveTab] = useState<TabType>('members');

  return (
    <div className="p-4 md:p-6 space-y-4 md:space-y-6 w-full max-w-full overflow-x-hidden">
      {/* Header */}
      <div className="flex items-center justify-between">
        <div>
          <div className="flex items-center space-x-3">
            <Users className="h-6 w-6 text-primary-600" />
            <h2 className="text-2xl font-bold text-gray-900">Family</h2>
          </div>
          <p className="text-gray-600">Manage family members and their investments</p>
        </div>
      </div>

      {/* Tabs */}
      <div className="flex space-x-4 border-b border-gray-200">
        <button
          onClick={() => setActiveTab('members')}
          className={`px-4 py-2 font-medium border-b-2 transition-colors ${
            activeTab === 'members'
              ? 'border-primary-600 text-primary-600'
              : 'border-transparent text-gray-500 hover:text-gray-700'
          }`}
        >
          Members
        </button>
        <button
          onClick={() => setActiveTab('investments')}
          className={`px-4 py-2 font-medium border-b-2 transition-colors ${
            activeTab === 'investments'
              ? 'border-primary-600 text-primary-600'
              : 'border-transparent text-gray-500 hover:text-gray-700'
          }`}
        >
          Investments
        </button>
      </div>

      {/* Tab Content */}
      <div>
        {activeTab === 'members' ? (
          <div className="mt-6">
            <FamilyMembers portfolio={portfolio} setPortfolio={setPortfolio} hideHeader={true} user={user} />
          </div>
        ) : (
          <div className="mt-6">
            <Investments portfolio={portfolio} setPortfolio={setPortfolio} hideHeader={true} />
          </div>
        )}
      </div>
    </div>
  );
};

export default Family;

